function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1936(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.58,
    height: 9.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 4.68
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.36,
    width: 24.58,
    height: 26.55,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 22.634999999999998
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.92,
    width: 24.58,
    height: 33.06,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9159999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 52.45
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 68.97,
    width: 24.58,
    height: 37.87,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.096666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 87.905
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.85,
    width: 24.58,
    height: 40.7,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9159999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 127.19999999999999
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 147.55,
    width: 24.58,
    height: 40.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.731111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 167.91500000000002
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 188.28,
    width: 24.58,
    height: 44.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.096666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 210.46
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 232.64,
    width: 24.58,
    height: 48.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9159999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 256.935
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 281.22,
    width: 24.58,
    height: 52.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.511428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 307.65000000000003
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 334.09,
    width: 24.58,
    height: 53.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.511428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 360.79499999999996
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 387.5,
    width: 24.58,
    height: 57.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.096666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 416.105
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 444.7,
    width: 24.58,
    height: 59.26,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 474.33
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 503.96,
    width: 24.58,
    height: 60.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9159999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 534.395
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 564.83,
    width: 24.58,
    height: 67.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4579999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 598.585
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 632.34,
    width: 24.58,
    height: 67.66,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.29,
    y: 666.1700000000001
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 0,
    width: 36.65,
    height: 46.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.905,
    y: 23.3
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.23,
    y: 0,
    width: 37.33,
    height: 46.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.221666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.895,
    y: 23.3
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 0,
    width: 37.54,
    height: 46.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.33,
    y: 23.3
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.1,
    y: 0,
    width: 37.7,
    height: 46.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.385714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 154.95,
    y: 23.3
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.81,
    y: 0,
    width: 38.47,
    height: 46.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.04500000000002,
    y: 23.3
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.28,
    y: 0,
    width: 38.68,
    height: 46.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.525714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.62,
    y: 23.3
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.96,
    y: 0,
    width: 38.98,
    height: 46.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.45,
    y: 23.3
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.93,
    y: 0,
    width: 40.14,
    height: 46.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310,
    y: 23.3
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.07,
    y: 0,
    width: 40.46,
    height: 46.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.3,
    y: 23.3
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.53,
    y: 0,
    width: 40.72,
    height: 46.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.89,
    y: 23.3
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.25,
    y: 0,
    width: 43.81,
    height: 46.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.381
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.155,
    y: 23.3
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.06,
    y: 0,
    width: 44.59,
    height: 46.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4316666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.355,
    y: 23.3
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.65,
    y: 0,
    width: 46.53,
    height: 46.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.915,
    y: 23.3
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.18,
    y: 0,
    width: 47.97,
    height: 46.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.165,
    y: 23.3
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.15,
    y: 0,
    width: 51.13,
    height: 46.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6571428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.715,
    y: 23.3
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 645.28,
    y: 0,
    width: 54.72,
    height: 46.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.64,
    y: 23.3
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 46.6,
    width: 53.16,
    height: 47.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.799
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 70.595
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 94.6,
    width: 53.16,
    height: 52.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 121.03
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 147.46,
    width: 53.16,
    height: 54.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.832727272727272
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 174.625
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 201.78,
    width: 53.16,
    height: 54.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 229.12
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 256.47,
    width: 53.16,
    height: 56.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 284.69000000000005
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 312.91,
    width: 53.16,
    height: 56.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 341.22
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 369.53,
    width: 53.16,
    height: 59.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.594285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 399.34
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 429.15,
    width: 53.16,
    height: 65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 461.65
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 494.15,
    width: 53.16,
    height: 65.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 526.725
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 559.3,
    width: 53.16,
    height: 67.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.594285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 592.91
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 626.52,
    width: 53.16,
    height: 73.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.16,
    y: 663.26
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.74,
    y: 46.6,
    width: 67.64,
    height: 70.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.56,
    y: 81.775
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.37,
    y: 46.6,
    width: 68.36,
    height: 70.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.836
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.55,
    y: 81.775
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.73,
    y: 46.6,
    width: 73.94,
    height: 70.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.395454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.7,
    y: 81.775
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.67,
    y: 46.6,
    width: 76.43,
    height: 70.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.049999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.885,
    y: 81.775
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.11,
    y: 46.6,
    width: 78.75,
    height: 70.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.485,
    y: 81.775
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.86,
    y: 46.6,
    width: 84.14,
    height: 70.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.93,
    y: 81.775
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.99,
    y: 46.6,
    width: 85.4,
    height: 70.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.034999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.69,
    y: 81.775
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 612.4,
    y: 46.6,
    width: 87.6,
    height: 70.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 656.1999999999999,
    y: 81.775
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.74,
    y: 116.96,
    width: 93.41,
    height: 79.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.292857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.445,
    y: 156.48499999999999
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.74,
    y: 196.01,
    width: 93.41,
    height: 85.4,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.233333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.445,
    y: 238.70999999999998
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.74,
    y: 281.41,
    width: 93.41,
    height: 119.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.568333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.445,
    y: 341.17
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.74,
    y: 400.94,
    width: 93.41,
    height: 137.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.67625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.445,
    y: 469.495
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.74,
    y: 538.04,
    width: 93.41,
    height: 161.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.568333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.445,
    y: 619.02
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.15,
    y: 116.96,
    width: 136.73,
    height: 134.81,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.468333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.515,
    y: 184.365
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.87,
    y: 116.96,
    width: 169.88,
    height: 134.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.255454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.81,
    y: 184.365
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.75,
    y: 116.96,
    width: 222.25,
    height: 134.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.7025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.875,
    y: 184.365
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.15,
    y: 251.77,
    width: 199.6,
    height: 216.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 33.266666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.95,
    y: 359.9
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.15,
    y: 468.03,
    width: 199.6,
    height: 231.97,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 39.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.95,
    y: 584.015
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.75,
    y: 251.77,
    width: 329.25,
    height: 189.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.6425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.375,
    y: 346.34000000000003
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.75,
    y: 440.91,
    width: 329.25,
    height: 259.09,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 51.818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.375,
    y: 570.455
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1936);
export default __webpack_public_path__ + "static/media/1936.119a45ff316a4f186a72d5c4f96c0858.svg";
export { ForwardRef as ReactComponent };